// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__IJHl2","desabilitar":"OptionSelect_desabilitar__wEFAM","focado":"OptionSelect_focado__kCZif","novo":"OptionSelect_novo__wTHv9"};